// Module
var code = "<div class=\"AlertBanner\" ng-if=\"AlertBanner.displayedAlert && !AlertBanner.dismissed\"> <div class=\"AlertBanner__placeholder\"></div> <div class=\"AlertBanner__message\"> {{::AlertBanner.displayedAlert.message}} </div> <button class=\"AlertBanner__dismiss\" ng-click=\"AlertBanner.dismissAlert()\"> <dls-icon-close></dls-icon-close> </button> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/alertBanner/alertBanner.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;